export const messages = {
  en: {
    transactionOutLog: {
      queryCondition: 'Query Condition',
      startTime: 'Please enter start time',
      endTime: 'Please enter end time',
      query: 'Query',
      logTitle: 'Third Party Call Log',
      serial: 'Serial',
      address: 'Address',
      requestHeader: 'Request Header',
      requestMessage: 'Request Message',
      responseHeader: 'Response Header',
      responseMessage: 'Response Message',
      costTime: 'Cost Time',
      status: 'Status',
      callTime: 'Call Time',
      success: 'Success',
      fail: 'Fail',
      tip1: 'Tips:',
      tip2: 'If there is no log record, please confirm whether the value of "Record Log for External System Calls" in the system switch under Configuration > Configuration Center is changed to ON, and refresh the cache in Cache Management',
      iot: 'IoT',
      wechat: 'WeChat',
      wechatPay: 'WeChat Pay',
      oss: 'OSS',
      sms: 'SMS',
      view: 'View',
      detailTitle: 'Log Detail',
      baseInfo: 'Basic Info',
      requestMethod: 'Request Method',
      copy: 'Copy',
      copySuccess: 'Copied Successfully',
      copyFail: 'Copy Failed',
      fetchError: 'Failed to fetch transaction out logs'
    }
  },
  zh: {
    transactionOutLog: {
      queryCondition: '查询条件',
      startTime: '请输入开始时间',
      endTime: '请输入结束时间',
      query: '查询',
      logTitle: '调用三方日志',
      serial: '流水',
      address: '地址',
      requestHeader: '请求头',
      requestMessage: '请求报文',
      responseHeader: '返回头',
      responseMessage: '返回报文',
      costTime: '耗时',
      status: '状态',
      callTime: '调用时间',
      success: '成功',
      fail: '失败',
      tip1: '温馨提示：',
      tip2: '如果没有日志记录，请确认配置》配置中心下系统开关中，将名称为《调用外部系统记录日志》的值是否改为ON，并在缓存管理中刷新缓存',
      iot: '物联网',
      wechat: '微信',
      wechatPay: '微信支付',
      oss: 'OSS',
      sms: '短信',
      view: '查看',
      detailTitle: '日志详情',
      baseInfo: '基础信息',
      requestMethod: '请求方式',
      copy: '复制',
      copySuccess: '复制成功',
      copyFail: '复制失败',
      fetchError: '获取调用日志失败'
    }
  },
  'zh-TW': {
    transactionOutLog: {
      queryCondition: '查詢條件',
      startTime: '請輸入開始時間',
      endTime: '請輸入結束時間',
      query: '查詢',
      logTitle: '調用三方日誌',
      serial: '流水',
      address: '地址',
      requestHeader: '請求頭',
      requestMessage: '請求報文',
      responseHeader: '返回頭',
      responseMessage: '返回報文',
      costTime: '耗時',
      status: '狀態',
      callTime: '調用時間',
      success: '成功',
      fail: '失敗',
      tip1: '温馨提示：',
      tip2: '如果沒有日誌記錄，請確認配置》配置中心下系統開關中，將名稱為《調用外部系統記錄日誌》的值是否改為ON，並在緩存管理中刷新緩存',
      iot: '物聯網',
      wechat: '微信',
      wechatPay: '微信支付',
      oss: 'OSS',
      sms: '短信',
      view: '查看',
      detailTitle: '日誌詳情',
      baseInfo: '基礎資訊',
      requestMethod: '請求方式',
      copy: '複製',
      copySuccess: '複製成功',
      copyFail: '複製失敗',
      fetchError: '獲取調用日誌失敗'
    }
  }
}